import gql from 'graphql-tag';

const ANSWER_SCALE = gql`
mutation answerScale($tester:ID!, $question:ID!, $answer: String!){
    answerScaleQuestion(participantId: $tester, campaignQuestionId: $question, answer: $answer)
}
`;

export default ANSWER_SCALE;
